/**
 * Formats grouped filter values for filter params
 *
 * e.g. Currently used for the project ref filter so that the items are filter param type aware
 * See useProjectBranches.ts for an example of how we append the group to the filter value
 */
export const formatGroupedFilterValuesForFilterParams = (
  filterValues: string[],
  groups: string[]
) => {
  const groupedData: { [key: string]: string[] } = {};
  for (const group of groups) {
    groupedData[group] = [];
  }
  for (const filterValue of filterValues) {
    const parts = filterValue.split("$");
    const group: string = parts[parts.length - 1];
    // Remove the group appended to the filter value
    // Removes the last $ and everything after it
    const value: string = filterValue.replace(/\$[^$]*$/, "");

    groupedData[group].push(value);
  }
  return groupedData;
};
